import * as Dropdown from '@radix-ui/react-dropdown-menu';
import { FiChevronDown } from 'react-icons/fi';
import { getAllEquipments } from 'api/equipments';
import { useEffect, useState } from 'react';
import classNames from 'utilities/ClassNames';

export type EquipmentProps = {
  id: number;
  unitId: number;
  name: string;
  desc: string;
  unitName: string | null;
  seqOrder: number;
  performanceIndexExpId: number | null;
  unityHashId: string;
  expressions: any[];
  tags: any[];
};

const EquipmentMappingModal = ({ onCancel, allEquipments, mappedEquipment, setMappedEquipment, mapEquipmentAction, equipmentMappingStatus }: { onCancel: any, allEquipments: EquipmentProps[], mappedEquipment: EquipmentProps | null, setMappedEquipment: React.Dispatch<React.SetStateAction<EquipmentProps | null>>, mapEquipmentAction: any, equipmentMappingStatus: 'fail' | 'success' | null }) => {

  return (
    <div className="h-screen w-screen bg-black/65 flex items-center justify-center fixed left-0 top-0 z-50"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onMouseMove={(e) => e.stopPropagation()}
      onWheel={(e) => e.stopPropagation()}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className="bg-dark w-72 rounded-xl">
        <h3 className='font-semibold text-lg 2xl:text-2xl p-2 bg-darkerBlack w-full rounded-md h-min text-center'>Map to an equipment:</h3>
        <div className='flex flex-col gap-2 py-4'>
          <div className='flex w-full px-4'>
            <div className='w-full'>
              {mappedEquipment ?
                mappedEquipment.name :
                'Choose an equipment'
              }
            </div>
            <div>
              <Dropdown.Root>
                <Dropdown.Trigger asChild>
                  <button
                    className="p-1 hover:bg-gray/20 rounded"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FiChevronDown size={14} />
                  </button>
                </Dropdown.Trigger>
                <Dropdown.Content
                  sideOffset={4}
                  className="z-50 bg-[#1B1B1B] border border-lightGray rounded-md p-1 text-sm text-white max-h-80 overflow-y-auto shadow-lg"
                >
                  {allEquipments.map((equipment, index) => (
                    <Dropdown.Item
                      className="px-3 py-1 rounded hover:bg-lightGray cursor-pointer"
                      key={index}
                      onSelect={() => setMappedEquipment(equipment)}
                    >
                      {equipment.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Content>
              </Dropdown.Root>
            </div>
          </div>
          {equipmentMappingStatus &&
            <div className='px-4'>
              {equipmentMappingStatus === 'fail' &&
                <p className='text-red'>Error mapping to an equipment</p>
              }
              {equipmentMappingStatus === 'success' &&
                <p className='text-green'>Mapped successfully</p>
              }
            </div>
          }
          <div className='flex w-full justify-between px-4 pt-4 gap-2'>
            <button
              className="btn"
              onClick={() => mapEquipmentAction()}
            >
              Confirm
            </button>
            <button
              className="btn-sec"
              onClick={() => onCancel()}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div >
  );
};

export default EquipmentMappingModal;